import { VOLUNTEERING_WEEK } from '../constants/volunteeringWeek.ts'

function startOfDay(date: Date): Date {
    const normalized = new Date(date)
    normalized.setHours(0, 0, 0, 0)
    return normalized
}

function endOfDay(date: Date): Date {
    const normalized = new Date(date)
    normalized.setHours(23, 59, 59, 999)
    return normalized
}

export function getVolunteeringWeekCreationStartBoundary(): Date {
    return startOfDay(VOLUNTEERING_WEEK.CREATION_START)
}

export function getVolunteeringWeekCreationDeadlineBoundary(): Date {
    return endOfDay(VOLUNTEERING_WEEK.CREATION_DEADLINE)
}

export function getVolunteeringWeekPublishBoundary(): Date {
    return startOfDay(VOLUNTEERING_WEEK.PUBLISH_DATE)
}

export function getVolunteeringWeekStartBoundary(): Date {
    return startOfDay(VOLUNTEERING_WEEK.START)
}

export function getVolunteeringWeekEndBoundary(): Date {
    return endOfDay(VOLUNTEERING_WEEK.END)
}

export function isWithinVolunteeringWeekCreationWindow(now: Date = new Date()): boolean {
    return now >= getVolunteeringWeekCreationStartBoundary() && now <= getVolunteeringWeekCreationDeadlineBoundary()
}

export function isWithinVolunteeringWeekVisibilityWindow(now: Date = new Date()): boolean {
    return now >= getVolunteeringWeekPublishBoundary() && now <= getVolunteeringWeekEndBoundary()
}

export function isWithinVolunteeringWeekRange(date: Date): boolean {
    return date >= getVolunteeringWeekStartBoundary() && date <= getVolunteeringWeekEndBoundary()
}
